import React, { Component } from 'react';
import AdminGeneralDefinitionsTable from './AdminGeneralDefinitionsTable';

export class AdminGeneralDefinitionsContent extends Component {
  render() {

    return (
      <AdminGeneralDefinitionsTable titleTableList={this.props.titleTableList} />
    )

  }
}

export default AdminGeneralDefinitionsTable


// WEBPACK FOOTER //
// ./src/components/Administration/AdminGeneralDefinitions/AdminGeneralDefinitionsContent.js